import { Dispatch, FC, SetStateAction } from "react";
import TableHeader from "../../../assets/components/Table/TableHeader";
import {
    Page,
    PaginationBar,
} from "../../../assets/components/PaginationBar/PaginationBar";
import { FetchHistoryService } from "../model";

interface Props {
    dataTableSize: number;
    pageNumber: Page;
    currentSizePage: number;
    pageSize: number;
    totalHistories: FetchHistoryService["totalHistories"];
    setCurrentPage: Dispatch<SetStateAction<Page>>;
}

const HistoryTableHeader: FC<Props> = ({
    pageSize,
    pageNumber = 0,
    totalHistories,
    setCurrentPage,
}) => {
    const calculatedDataTableLength = Math.min(
        totalHistories - pageNumber * pageSize,
        pageSize
    );

    const calculatedPageSize = pageSize;

    return (
        <TableHeader
            title="List of licenses"
            dataTableLength={calculatedDataTableLength}
            pageSize={calculatedPageSize}
        >
            <>
                <PaginationBar
                    currentPage={pageNumber as number}
                    currentPageHandler={setCurrentPage}
                    totalItems={totalHistories}
                    pageSize={pageSize}
                />
            </>
        </TableHeader>
    );
};

export default HistoryTableHeader;
